import { render, staticRenderFns } from "./Pagamentos.vue?vue&type=template&id=3089ef9f&"
import script from "./Pagamentos.vue?vue&type=script&lang=js&"
export * from "./Pagamentos.vue?vue&type=script&lang=js&"
import style0 from "./Pagamentos.vue?vue&type=style&index=0&id=3089ef9f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports